import React from 'react';
import { getMediaUrl } from '../../../api/hooks';

import './CopyrightedImage.scss';

const CopyrightedImage = ({image, size, alt}) => (
    <div className="image-container">
        <img src={getMediaUrl(image.id, image.context, size)} alt={alt} />
        <figcaption
            title={image.copyright && ('© ' + image.copyright)}
            className="copyrighted-image-caption"
        >
            {image.copyright && ('© ' + image.copyright)}
        </figcaption>
    </div>
);

export default CopyrightedImage;